import { pushRoute } from '../../lib/router.js';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import OrganizationHeader from '../../components/headers/PageHeaders/Organization/OrganizationHeader.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import EmployeesForm from '../../components/employees/EmployeesForm/EmployeesForm.jsx';
import {
  selectFlattenedOrgGroups,
  selectOrgGroups,
  updateGroups,
} from '../../modules/orgGroups.js';
import { useFetchFile } from '../../hooks/useFetchFile.js';
import { selectCurrentOrganizationId } from '../../modules/auth.js';
import { updateNotificationState } from '../../modules/notifications.js';
import { mapFinalFormErrors } from '../../lib/utils.js';
import {
  retrieveEmployees,
  selectEmployees,
  selectRetrieveEmployeesState,
} from '../../modules/employees.js';
import Empty from '../../components/Empty.jsx';
import { loadingContent } from '../../components/EmptyStates.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import { retrieveOrgStructureUploadStatus } from '../../modules/organizations.js';

const mapErrors = mapFinalFormErrors('Failed to save');

const mapStateToProps = (state, ownProps) => {
  return {
    groups: selectOrgGroups(state),
    flattenedGroups: selectFlattenedOrgGroups(state),
    employees: selectEmployees(state),
    organizationId: selectCurrentOrganizationId(state),
    apiUrl: state.config.apiUrl,
    slug: ownProps.slug,
    retrieveSuccess: selectRetrieveEmployeesState(state).success,
  };
};

const mapDispatchToProps = {
  retrieveEmployees,
  updateNotificationState,
  updateGroups,
  retrieveOrgStructureUploadStatus,
};
const EmployeesFormContainer = ({
  organizationId,
  apiUrl,
  slug,
  updateNotificationState,
  employees,
  retrieveEmployees,
  updateGroups,
  retrieveSuccess,
  retrieveOrgStructureUploadStatus,
}) => {
  const [replaceMethod, setReplaceMethod] = useState('add');

  const [employeesTree, setEmployeesTree] = useState([]);

  const formRef = useRef(null);

  const { downloadBlob } = useFetchFile();

  const onDownloadCsv = () => {
    downloadBlob(
      apiUrl,
      `organizations/${organizationId}/group_structure_csv`,
      null,
      'current-group-structure CSV',
      'csv'
    );
  };

  const notify = () => {
    updateNotificationState({
      isShown: true,
      type: 'success',
      forPath: '/organization/employees',
      message:
        'Org Structure successfully changed!\n' +
        `We’re updating your active ${getOrgTermsContent('initiatives')} and change impacts to follow the changes you have just uploaded. Items with end date in the past will retain the old structure, naming and emails.\n` +
        'Once ready, we’ll update you via email.',
    });
  };

  const onSubmit = () => {
    const composedData = () => {
      const formData = new FormData(formRef.current);
      const composedFormData = new FormData();
      composedFormData.append('manually', false);
      composedFormData.append('merge', replaceMethod === 'add');
      composedFormData.append('csv_file', formData.get('csv_file'));
      return composedFormData;
    };

    const submitPromise = updateGroups(organizationId, composedData());
    return submitPromise
      .then(() => {
        notify();
        retrieveOrgStructureUploadStatus(organizationId);
        pushRoute('organization/employees');
      })

      .catch(mapErrors);
  };

  useEffect(() => {
    retrieveEmployees({ active: true });
  }, []);

  useEffect(() => {
    employees && setEmployeesTree(employees);
  }, [retrieveSuccess]);

  return (
    <React.Fragment>
      <OrganizationHeader slug={slug} />
      <SubHeader flexJustify small>
        <h2>Edit Employees</h2>
      </SubHeader>
      {retrieveSuccess ? (
        <Grid fluid className="m-0">
          <Row>
            <Col sm={12}>
              <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
                <Row>
                  <Col sm={10} smOffset={1}>
                    <Form
                      employeesTree={employeesTree}
                      replaceMethod={replaceMethod}
                      setReplaceMethod={setReplaceMethod}
                      onSubmit={onSubmit}
                      onDownloadCsv={onDownloadCsv}
                      formRef={formRef}
                      component={EmployeesForm}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Grid>
      ) : (
        <Empty simplified content={loadingContent} />
      )}
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeesFormContainer);
